import { render } from "./UiDropdown.vue?vue&type=template&id=32e7613a&ts=true"
import script from "./UiDropdown.vue?vue&type=script&lang=ts"
export * from "./UiDropdown.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./UiDropdown.vue?vue&type=style&index=0&id=32e7613a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__